module.exports = {"type":"object","properties":{"voter":{"title":"Voter","type":"string","x-schema-form":{"type":"entitylookup","lookuptype":"contact"}},"blocked":{"type":"boolean","title":"Blocked","description":"The voter is not allowed to cast a vote for this property currently"},"votingCertificate":{"type":"string","title":"Voting Certificate","x-schema-form":{"type":"single-file-upload"}}},"required":[]}


//////////////////
// WEBPACK FOOTER
// ./client/components/schemas/evoting-no-weight.json
// module id = 610
// module chunks = 0